import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, { memo } from 'react';
import util from '../../util/index';

const Beaker = ({
	lowerLimit,
	upperLimit,
	injSet,
	unit,
	title,
	value,
}) => {
	const theme = useTheme();
	let minValue = lowerLimit;
	let maxValue = upperLimit;
	let maxRange = maxValue > value ? maxValue : value;
	//special case
	if (maxRange < minValue) {
		maxRange = minValue;
	}
	let minValuePercentage = util.calculatePercentage(maxRange, minValue);
	let maxvaluePercentage = util.calculatePercentage(maxRange, maxValue);
	let valuePercentage = util.calculatePercentage(maxRange, value);
	let setValuePercentage = util.calculatePercentage(maxRange, injSet);
	if (minValuePercentage > 30) {
		minValuePercentage = minValuePercentage - 30;
		maxvaluePercentage = maxvaluePercentage > 15 ? maxvaluePercentage - 15 : maxvaluePercentage;
		valuePercentage = valuePercentage > 15 ? valuePercentage - 15 : valuePercentage;
		setValuePercentage = setValuePercentage > 15 ? setValuePercentage - 15 : setValuePercentage;
	} else if (minValuePercentage > 20) {
		minValuePercentage = minValuePercentage - 20;
		maxvaluePercentage = maxvaluePercentage > 10 ? maxvaluePercentage - 10 : maxvaluePercentage;
		valuePercentage = valuePercentage > 10 ? valuePercentage - 10 : valuePercentage;
		setValuePercentage = setValuePercentage > 10 ? setValuePercentage - 10 : setValuePercentage;
	} else if (minValuePercentage > 10) {
		minValuePercentage = minValuePercentage - 10;
		maxvaluePercentage = maxvaluePercentage > 5 ? maxvaluePercentage - 5 : maxvaluePercentage;
		valuePercentage = valuePercentage > 5 ? valuePercentage - 5 : valuePercentage;
		setValuePercentage = setValuePercentage > 5 ? setValuePercentage - 5 : setValuePercentage;
	}

	

	return (
		<Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
			<Typography textAlign={'center'} fontWeight={'bold'} variant="body2" fontSize={11} gutterBottom>
				{title}
			</Typography>

			<Box display={'flex'} className="custom-cylinde-inner-top">
				<div className="custom-cylinde-inner-top-left"></div>
				<div className="custom-cylinde-inner-top-right"></div>
			</Box>
			<Box className="custom-cylinde-outer">
				<div className="custom-cylinde-inner">
					<div
						style={{
							width: '50px',
							height: '26px',
							position: 'absolute',
							backgroundColor: theme.palette.error.light
						}}
					></div>
					<div className="line" style={{ top: 100 - maxvaluePercentage + '%', width: '13em', left: '-9%' }}>
						<hr style={{ border: '1px dashed #000000' }} />
						<button style={{ top: -10, left: 71, background: 'none', border: 'none' }}>
							Max({maxValue} {unit})
						</button>
					</div>
					<div className="line" style={{ top: 100 - setValuePercentage + '%', width: '13em', left: '-9%' }}>
						<hr />
						<button style={{ top: -10, left: 71, background: 'none', border: 'none' }}>
							Set({injSet} {unit})
						</button>
					</div>
					<div className="line" style={{ top: `${100 - valuePercentage}%`, width: '13em', left: '-18%' }}>
						<hr />
						<button style={{ top: -10, left: -75, background: 'none', border: 'none' }}>
							Injected({value} {unit})
						</button>
					</div>
					<div className="dashed-line" style={{ top: 100 - minValuePercentage + '%', width: '12em', left: '-9%' }}>
						<hr style={{ border: '1px dashed #000000' }} />
						<button style={{ top: -3, left: -71, background: 'none', border: 'none' }}>
						Min({minValue}) {unit}
						</button>
					</div>
					<div
						className="custom-cylinder"
						style={{ height: 100 - minValuePercentage + '%', backgroundColor: theme.palette.success.light }}
					></div>
					<div
						className="custom-cylinder"
						style={{ height: minValuePercentage + '%', backgroundColor: theme.palette.error.light }}
					></div>
				</div>
			</Box>
		</Box>
	);
};

export default memo(Beaker);